import { SxProps, Theme } from '@mui/material';

export const gridContainerStyles: SxProps<Theme> = {
  width: '1200px',
  maxWidth: '100%',
};

export const gridComponentStyles = {
  borderRadius: '6px',
  overflow: 'hidden',
  boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
};
